const lama3Pricing = [
  { lamas: 4, heightInches: 13.75, width24: 128.0, width30: 128.0, width36: 128.0 },
  { lamas: 5, heightInches: 16.75, width24: 128.0, width30: 128.0, width36: 144.49 },
  { lamas: 6, heightInches: 19.75, width24: 128.0, width30: 140.41, width36: 168.49 },
  { lamas: 7, heightInches: 22.75, width24: 128.0, width30: 160.41, width36: 192.49 },
  { lamas: 8, heightInches: 25.75, width24: 148.0, width30: 180.41, width36: 216.49 },
  { lamas: 9, heightInches: 28.75, width24: 160.0, width30: 200.41, width36: 240.49 },
  { lamas: 10, heightInches: 31.75, width24: 176.0, width30: 220.41, width36: 264.49 },
  { lamas: 11, heightInches: 34.75, width24: 192.0, width30: 240.41, width36: 288.49 },
  { lamas: 12, heightInches: 37.75, width24: 208.0, width30: 260.41, width36: 312.49 },
  { lamas: 13, heightInches: 40.75, width24: 224.0, width30: 280.41, width36: 336.49 },
  { lamas: 14, heightInches: 43.75, width24: 240.0, width30: 300.41, width36: 360.49 },
  { lamas: 15, heightInches: 46.75, width24: 256.0, width30: 320.41, width36: 384.49 },
  { lamas: 16, heightInches: 49.75, width24: 272.0, width30: 340.41, width36: 408.49 },
  { lamas: 17, heightInches: 52.75, width24: 288.0, width30: 360.41, width36: 432.49 },
  { lamas: 18, heightInches: 55.75, width24: 304.0, width30: 380.41, width36: 456.49 },
  { lamas: 19, heightInches: 58.75, width24: 320.0, width30: 400.41, width36: 480.49 },
  { lamas: 20, heightInches: 61.75, width24: 336.0, width30: 420.41, width36: 504.49 },
  { lamas: 21, heightInches: 64.75, width24: 352.0, width30: 440.41, width36: 528.49 },
  { lamas: 22, heightInches: 67.75, width24: 368.0, width30: 460.41, width36: 552.49 },
  { lamas: 23, heightInches: 70.75, width24: 384.0, width30: 480.41, width36: 576.49 },
  { lamas: 24, heightInches: 73.75, width24: 400.0, width30: 500.41, width36: 600.49 },
  { lamas: 25, heightInches: 76.75, width24: 416.0, width30: 520.41, width36: 624.49 },
  { lamas: 26, heightInches: 79.75, width24: 432.0, width30: 540.41, width36: 648.49 },
  { lamas: 27, heightInches: 82.75, width24: 448.0, width30: 560.41, width36: 672.49 },
  { lamas: 28, heightInches: 85.75, width24: 464.0, width30: 580.41, width36: 696.49 },
  { lamas: 29, heightInches: 88.75, width24: 480.0, width30: 600.41, width36: 720.49 },
  { lamas: 30, heightInches: 91.75, width24: 496.0, width30: 620.41, width36: 744.49 },
  { lamas: 31, heightInches: 94.75, width24: 512.0, width30: 640.41, width36: 768.49 },
];

const lama4Pricing = [
  { lamas: 3, heightInches: 13.75, width24: 132.8, width30: 132.8, width36: 132.8 },
  { lamas: 4, heightInches: 17.75, width24: 132.8, width30: 132.8, width36: 152.49 },
  { lamas: 5, heightInches: 21.75, width24: 132.8, width30: 153.74, width36: 184.49 },
  { lamas: 6, heightInches: 25.75, width24: 132.8, width30: 180.41, width36: 216.49 },
  { lamas: 7, heightInches: 29.75, width24: 165.66, width30: 207.08, width36: 248.48 },
  { lamas: 8, heightInches: 33.75, width24: 187.0, width30: 233.74, width36: 280.49 },
  { lamas: 9, heightInches: 37.75, width24: 208.33, width30: 260.41, width36: 312.49 },
  { lamas: 10, heightInches: 41.75, width24: 229.66, width30: 287.08, width36: 344.49 },
  { lamas: 11, heightInches: 45.75, width24: 251.0, width30: 313.74, width36: 376.49 },
  { lamas: 12, heightInches: 49.75, width24: 272.33, width30: 340.41, width36: 408.49 },
  { lamas: 13, heightInches: 53.75, width24: 293.66, width30: 367.08, width36: 440.49 },
  { lamas: 14, heightInches: 57.75, width24: 315.0, width30: 393.74, width36: 472.49 },
  { lamas: 15, heightInches: 61.75, width24: 336.33, width30: 420.41, width36: 504.49 },
  { lamas: 16, heightInches: 65.75, width24: 357.66, width30: 447.08, width36: 536.49 },
  { lamas: 17, heightInches: 69.75, width24: 379.0, width30: 473.74, width36: 568.49 },
  { lamas: 18, heightInches: 73.75, width24: 400.33, width30: 500.41, width36: 600.49 },
  { lamas: 19, heightInches: 77.75, width24: 421.66, width30: 527.08, width36: 632.49 },
  { lamas: 20, heightInches: 81.75, width24: 442.99, width30: 553.74, width36: 664.49 },
  { lamas: 21, heightInches: 85.75, width24: 464.33, width30: 580.41, width36: 696.49 },
  { lamas: 22, heightInches: 88.75, width24: 485.66, width30: 607.08, width36: 728.49 },
  { lamas: 23, heightInches: 93.75, width24: 507.0, width30: 633.74, width36: 760.49 },
];

const lama6Pricing = [
  { lamas: 4, heightInches: 13.75, width24: 107.2, width30: 107.2, width36: 107.2 },
  { lamas: 6, heightInches: 19.75, width24: 107.2, width30: 117.6, width36: 141.12 },
  { lamas: 8, heightInches: 25.75, width24: 123.28, width30: 151.1, width36: 181.31 },
  { lamas: 10, heightInches: 31.75, width24: 147.68, width30: 185.59, width36: 221.52 },
  { lamas: 12, heightInches: 37.75, width24: 174.48, width30: 218.09, width36: 261.71 },
  { lamas: 14, heightInches: 43.75, width24: 201.28, width30: 250.6, width36: 303.52 },
  { lamas: 16, heightInches: 49.75, width24: 228.28, width30: 285.1, width36: 342.11 },
  { lamas: 18, heightInches: 55.75, width24: 254.88, width30: 318.59, width36: 382.32 },
  { lamas: 20, heightInches: 61.75, width24: 281.68, width30: 352.08, width36: 422.51 },
  { lamas: 22, heightInches: 67.75, width24: 308.48, width30: 385.6, width36: 462.72 },
  { lamas: 24, heightInches: 73.75, width24: 335.28, width30: 419.1, width36: 502.91 },
  { lamas: 26, heightInches: 79.75, width24: 362.08, width30: 452.59, width36: 543.12 },
  { lamas: 28, heightInches: 85.75, width24: 388.88, width30: 486.09, width36: 583.31 },
  { lamas: 30, heightInches: 91.75, width24: 415.68, width30: 519.6, width36: 623.52 },
];

export const windowPricingTables = {
  lama3: lama3Pricing,
  lama4: lama4Pricing,
  lama6: lama6Pricing,
};

export const getWindowBasePrice = (widthInches, heightInches, series = 'lama3') => {
  if (!widthInches || !heightInches) return null;
  const table = windowPricingTables[series] || windowPricingTables.lama3;
  const widthBuckets = [
    { max: 24, column: 'width24' },
    { max: 30, column: 'width30' },
    { max: 36, column: 'width36' },
  ];

  let bucket = widthBuckets.find((b) => widthInches <= b.max);
  let widthExceeded = false;
  if (!bucket) {
    bucket = widthBuckets[widthBuckets.length - 1];
    widthExceeded = true;
  }

  const entry = table.find((row) => heightInches <= row.heightInches) || table[table.length - 1];
  const price = entry[bucket.column];
  return {
    price,
    widthBucket: bucket.max,
    heightReference: entry.heightInches,
    lamas: entry.lamas,
    series,
    widthExceeded,
  };
};

export default windowPricingTables;
